import Lang from './language.json';

class I18n {
  constructor() {
    this.language = 'ko';
    this.enable = true;
  }

  setLanguage(lang) {
    if (this.enable) {
      this.language = lang;
    }
  }

  setEnable() {
    this.resetLanguage();
    this.enable = true;
  }

  setDisable() {
    this.resetLanguage();
    this.enable = false;
  }

  resetLanguage() {
    this.language = 'ko';
  }

  get(key, lang = null) {
    if (!this.enable) {
      return Lang[key].ko;
    }
    return Lang[key][lang || this.language];
  }
}

const instance = new I18n();
export default instance;
